import { css as r, styled as o } from "styled-components";
import { Theme as t } from "../../../styles/themes/index.js";
const e = r`
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
    animation: load 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }

  @keyframes load {
    from {
      left: -150px;
    }
    to {
      left: 100%;
    }
  }
`, i = r`
  height: 4px;
  border-radius: 2px;
  background-color: rgb(${t.colors.Golf});
  position: relative;
  overflow: hidden;
  margin-bottom: 14px;

  ${e}

  &:before {
    background: linear-gradient(
      to right,
      transparent 0%,
      #d7d7d7 50%,
      transparent 100%
    );
  }
`, d = o.div`
  display: flex;
  padding: 12px 16px;
  margin-bottom: 1px;
  align-items: center;
`, p = o.div`
  height: 48px;
  width: 48px;
  margin-right: 16px;
  border-radius: 4px;
  background-color: rgb(${t.colors.Golf});
  position: relative;
  overflow: hidden;

  ${e}

  &:before {
    background: linear-gradient(
      to right,
      transparent 0%,
      #f7f7f8 50%,
      transparent 100%
    );
  }
`, s = o.div`
  ${i}
  width: 211px;
`, l = o.div`
  ${i}
  width: 248px;
`, c = o.div`
  display: flex;
`, f = o.div`
  ${i}
  width: 86px;
  margin: 0 8px 0 0;
`, g = o.div`
  ${i}
  width: 22px;
  margin: 0;
  background-color: rgb(${t.colors.Golf});
`;
export {
  d as Container,
  s as FirstLine,
  g as FourthLine,
  p as Image,
  c as LineContainer,
  l as SecondLine,
  f as ThirdLine
};
